import { render } from "./CreateUserModal.vue?vue&type=template&id=baccda48"
import script from "./CreateUserModal.vue?vue&type=script&lang=js"
export * from "./CreateUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__